// RecordCard.tsx

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, Typography, IconButton } from "@mui/material";

type RecordCardProps = {
  title: string;
  onDelete?: () => void;
  disableDelete?: boolean;
  children: React.ReactNode;
};

export const RecordCard = ({
  title,
  onDelete,
  disableDelete,
  children,
}: RecordCardProps) => (
  <Box
    sx={{
      p: 2,
      mb: 2,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      bgcolor: "background.default",
    }}
  >
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={2}
    >
      <Typography
        variant="body2"
        fontWeight={600}
      >
        {title}
      </Typography>

      <IconButton
        color="error"
        onClick={onDelete}
        disabled={disableDelete}
        size="small"
      >
        <DeleteOutlineIcon />
      </IconButton>
    </Box>

    {children}
  </Box>
);